/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'eway-error': {
    width: 10,
    height: 12,
    viewBox: '0 0 10 12',
    data: '<g _stroke="#E25757" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M2.758 7.221h4.593M2.758 5.093h4.593M2.758 3.09h1.407M1 .75h5.545l.978.929 1.333 1.135v7.917L7.461 9.46 6.238 10.73 4.928 9.46 3.447 10.73 2.362 9.46 1 10.73z"/><path pid="1" d="M6.163.75v2.34h2.693"/></g>'
  }
})
